import { Bar } from 'react-chartjs-2';
import {
  Box,
  useTheme,
} from '@mui/material';
import PropTypes from "prop-types";
import { useRef } from 'react';

const VerticalBarGraph = ({ ...props }) => {
  const chartRef = useRef(null);
  var baseImg;
  const theme = useTheme();
  const options = {
    animation: {
      duration: 1,
      onComplete: function () {
        // baseImg = chartRef.current.toBase64Image();
        // console.log(baseImg);
      }
    },
    // animation: false,
    indexAxis: 'x',
    layout: { 
      padding: 5 
    },
    plugins: {
      legend: {
        display: false
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        ticks: {
          fontColor: theme.palette.text.secondary,
        },
        grid: {
          display: false,
          drawBorder: false,
        }
      },
      y:
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0
        },
        grid: {
          borderDash: [2],
          borderDashOffset: [2],
          drawBorder: false,
        }
      }
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    tooltips: {
      // backgroundColor: theme.palette.background.paper,
      // bodyFontColor: theme.palette.text.secondary,
      // borderColor: theme.palette.divider,
      // borderWidth: 1,
      // enabled: true,
      // footerFontColor: theme.palette.text.secondary,
      // intersect: false,
      // mode: 'x',
      // titleFontColor: theme.palette.text.primary,
      // shadowOffsetX: 3, test cheyyi
      // shadowOffsetY: 3,
      // shadowBlur: 10,
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%' //idhi choodu
        // minWidth: '100%',
        // maxWidth: '1200px'
      }}
      className={!props.data ? 'display-center' : ''}
    >
      <Bar
        ref={chartRef}
        data={props.data}
        options={options}
      />
    </Box>
  );
};

VerticalBarGraph.propTypes = {
  //   refreshBarChart: PropTypes.func,
  //   data: PropTypes.object
};

export default VerticalBarGraph;
